var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 0H0.521739C0.234783 0 0 0.234783 0 0.521739V10.4348C0 10.7217 0.234783 10.9565 0.521739 10.9565H10.4348C10.7217 10.9565 10.9565 10.7217 10.9565 10.4348V0.521739C10.9565 0.234783 10.7217 0 10.4348 0ZM8.73913 8.73913H2.21739V2.21739H8.73913V8.73913ZM23.4783 0H13.5652C13.2783 0 13.0435 0.234783 13.0435 0.521739V10.4348C13.0435 10.7217 13.2783 10.9565 13.5652 10.9565H23.4783C23.7652 10.9565 24 10.7217 24 10.4348V0.521739C24 0.234783 23.7652 0 23.4783 0ZM21.7826 8.73913H15.2609V2.21739H21.7826V8.73913ZM10.4348 13.0435H0.521739C0.234783 13.0435 0 13.2783 0 13.5652V23.4783C0 23.7652 0.234783 24 0.521739 24H10.4348C10.7217 24 10.9565 23.7652 10.9565 23.4783V13.5652C10.9565 13.2783 10.7217 13.0435 10.4348 13.0435ZM8.73913 21.7826H2.21739V15.2609H8.73913V21.7826ZM23.4783 13.0435H13.5652C13.2783 13.0435 13.0435 13.2783 13.0435 13.5652V23.4783C13.0435 23.7652 13.2783 24 13.5652 24H23.4783C23.7652 24 24 23.7652 24 23.4783V13.5652C24 13.2783 23.7652 13.0435 23.4783 13.0435ZM21.7826 21.7826H15.2609V15.2609H21.7826V21.7826Z",
    fill: "white",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.0626c35a8774645e80bb4f9b42df0532.svg";
export { ForwardRef as ReactComponent };